export default __webpack_public_path__ + "static/media/caret_down.6977d206.svg";